import { FC } from 'react'
import { useForm } from 'antd/es/form/Form'
import { Button, Col, DatePicker, Form, Row, Select, Table } from 'antd'
import OrderRequest from '../../../../../../../types/api/order-request'
import { QueryParams } from '../../../../../../../types/strapi/strapi'
import { useCreateReceiptMutation } from '../../../../../../../store/api/receipts-api'
import { useGetContractorsQuery } from '../../../../../../../store/api/contractors-api'
import { useCreateReceiptPositionMutation } from '../../../../../../../store/api/receipt-positions-api'
import { useUpdateOrderRequestMutation } from '../../../../../../../store/api/order-requests-api'
import { columns } from './constants/colums'
import dayjs, { Dayjs } from 'dayjs'
import {
    requiredDatePickerRules,
    requiredRules,
} from '../../../../../../../constants/forms/validation/rules'
import connect from '../../../../../../../helpers/api/connect'
import { outputDateFormat } from '../../../../../../../constants/constants'

const params: QueryParams = {
    filters: { type: { name: { $contains: 'Поставщик материала' } } },
}

interface GroupOperationsFormProps {
    selectedOrders: OrderRequest[]
    onSuccess: () => void
}

const GroupOperationsForm: FC<GroupOperationsFormProps> = ({ selectedOrders, onSuccess }) => {
    const [form] = useForm<{
        endDate: Dayjs
        supplier: string
        amounts: Record<string, number>
    }>()
    const dataSource: OrderRequest[] = selectedOrders || []
    const [createReceipt] = useCreateReceiptMutation()
    const [createReceiptPositions] = useCreateReceiptPositionMutation()
    const [updateOrderRequest] = useUpdateOrderRequestMutation()
    const { data: contractors } = useGetContractorsQuery(params)
    const receiptPositions: string[] = []
    const initialValues = {
        endDate: dayjs().add(3, 'day'),
        amounts: Object.fromEntries(selectedOrders.map(order => [order.documentId, order.amount])),
    }

    const saveReceiptPositions = async (amounts: Record<string, number>) => {
        for (const order of selectedOrders) {
            const res = await createReceiptPositions({
                data: {
                    positionType: 'Материал',
                    unit: { connect: [order.unit ? order.unit.documentId : ''] },
                    amount: amounts[order.documentId],
                    material: { connect: [order.material.documentId] },
                    initiator: { connect: [order.initiator.documentId] },
                    shipment: connect(order.shipment),
                    order_request: connect(order),
                },
            })
            if (res.data && res.data.data) {
                receiptPositions.push(res.data.data.documentId)
            }
        }
    }

    const saveReceipt = async () => {
        const value = form.getFieldsValue()
        if (receiptPositions.length === 0) {
            console.error('Не созданы позиции прихода')
            console.error(receiptPositions)
            return
        }
        await createReceipt({
            data: {
                receiptStatus: 'Создан',
                supplier: { connect: [value.supplier] },
                receipt_positions: { connect: receiptPositions },
                estimatedDate: value.endDate.toISOString(),
            },
        })
    }

    const markOrderRequestsProcessed = async () => {
        await Promise.all(
            selectedOrders.map(order =>
                updateOrderRequest({
                    docId: order.documentId,
                    body: {
                        data: {
                            requestStatus: 'Обработан',
                        },
                    },
                }).unwrap()
            )
        )
    }

    const onSave = async () => {
        try {
            await form.validateFields()
            const { amounts } = form.getFieldsValue(true)
            await saveReceiptPositions(amounts)
            await saveReceipt()
            await markOrderRequestsProcessed()
            form.resetFields()
            onSuccess()
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <Form form={form} layout={'vertical'} initialValues={initialValues}>
            <br />

            <Row gutter={12}>
                <Col sm={5}>
                    <Form.Item
                        name={'endDate'}
                        label={'Дата поставки'}
                        rules={requiredDatePickerRules}
                    >
                        <DatePicker format={outputDateFormat} />
                    </Form.Item>
                </Col>
                <Col sm={6}>
                    <Form.Item name={'supplier'} label={'Подрядчик'} rules={requiredRules}>
                        <Select
                            options={contractors?.data.map(x => ({
                                label: x.name,
                                value: x.documentId,
                            }))}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ marginBottom: 12 }}>
                <Table bordered columns={columns} dataSource={dataSource} rowKey={'documentId'} />
            </div>
            <Button type={'primary'} onClick={onSave}>
                Создать приход
            </Button>
        </Form>
    )
}

export default GroupOperationsForm
